module.exports = ".mat-raised-button{\n    width: 100%;\n}"